<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Dự án</h2>
        <div>
          <el-button @click="updateCount" size="small" type="info" class="btn-create">Update Count</el-button>
          <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button>
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-select v-model="filter.hot" filterable clearable placeholder="Nổi bật" class="input-select">
            <el-option
              v-for="item in lists.listHot"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới Dự án <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> Dự án / Tổng: {{ this.total_lessons }} Dự án
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            prop="description_max"
            width="40">
            <template slot-scope="scope">
              <div v-if="scope.row.big_description" class="item_active">
                <i class="fas fa-circle"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="image"
            width="120"
            align="center"
            label="Ảnh Dự án">
            <template slot-scope="scope">
              <img v-clipboard="scope.row.big_description"  @success="handleSuccess" @error="handleError" v-if="scope.row.image_thump" :src="scope.row.image_thump" class="course-image">
            </template>
          </el-table-column>
          <el-table-column
            width="250"
            label="Thông tin">
            <template slot-scope="scope">
              <div class="courses-info" v-clipboard="scope.row.big_description"  @success="handleSuccess" @error="handleError">
                  <span style="font-weight: bold; text-transform: uppercase; font-size: 16px">{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="view"
            width="100"
            align="center"
            label="Lượt xem">
            <template slot-scope="scope">
                <span v-clipboard="scope.row.big_description"  @success="handleSuccess" style="font-weight: bold">{{ scope.row.view }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="view"
            width="100"
            align="center"
            label="Lượt mới">
            <template slot-scope="scope">
                <span v-if="scope.row.view_old" style="font-weight: bold; color: green">{{ scope.row.view_old_txt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="priority"
            width="100"
            align="center"
            label="Độ ưu tiên">
            <template slot-scope="scope">
                <span style="font-weight: bold">{{ scope.row.priority }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="160"
            label="Trạng thái">
            <template slot-scope="scope">
              <div v-if="scope.row.status" class="item_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
              <div v-else class="item_not_active">
                <i class="fas fa-circle"></i>
                <span>{{ scope.row.status_txt }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="Kích hoạt"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeStatus(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Nổi bật"
            width="80"
            align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.hot"
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                @change="changeHot(scope.row)">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="Hành động"
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip effect="dark" content="Xem" placement="top">
                  <span @click="showModel(scope.row)">
                    <i class="fas fa-search icon-search"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Sửa" placement="top">
                  <span @click="updateModel(scope.row)">
                    <i class="far fa-edit icon-update"></i>
                  </span>
                </el-tooltip>
                <el-tooltip effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Projects',
  metaInfo () {
    return {
      title: 'Dự án'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      total_lessons: 0,
      filter: {
        q: '',
        status: '',
        hot: '',
        daterange: '',
        page: 1,
        limit: 25,
        sort: 'priority:-1',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Tên Dự án',
          groupFiled: [
            { label: 'name:-1', text: 'Tăng dần' },
            { label: 'name:1', text: 'Giảm dần' }
          ]
        },
        {
          groupName: 'Độ ưu tiên',
          groupFiled: [
            { label: 'priority:1', text: 'Tăng dần' },
            { label: 'priority:-1', text: 'Giảm dần' }
          ]
        },
        {
          groupName: 'Lượt xem',
          groupFiled: [
            { label: 'view:1', text: 'Tăng dần' },
            { label: 'view:-1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 1, value: 'Kích hoạt'},
          {key: 0, value: 'Chưa kích hoạt'}
        ],
        listHot: [
          {key: 1, value: 'Nổi bật'},
          {key: 0, value: 'Bình thường'}
        ],
        listCategoryCourse: [
          {key: 0, value: 'Chọn lĩnh vực'}
        ],
        listTeacher: [
          {key: 0, value: 'Chọn giảng viên'}
        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'projects-index', text: 'Dự án' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'projects-create'})
    },
    updateCount () {
      this.loading = true
      axios.post('projects/update-view-old').then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success',
              duration: 500
            })
            this.fetchDatabaseModel()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('projects', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về lĩnh vực Dự án
    fetchListCategoryCourse () {
      axios.get('category-courses', {params: {'status': 1}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listCategoryCourse = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Fetch dữ liệu về giảng viên
    fetchListTeacher () {
      axios.get('users', {params: {'status': 1, 'system_manager': 0, 'user_type': 2}}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listTeacher = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      window.open(model.link_view, '_blank')
      // this.$router.push({name: 'projects-show', params: {course_id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'projects-update', params: {course_id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('projects/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeHot (model) {
      let dataUpdate = {
        'hot': model.hot
      }
      axios.post('projects/update-hot/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa Dự án: ' + model.name, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('projects/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    },
    handleSuccess (e) {
      this.$notify({
        title: 'Thành công',
        message: 'Copy nội dung thành công',
        type: 'success',
        duration: 1000
      })
    },
    handleError (e) {

    }
  },
  watch: {
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.hot': function () {
      this.fetchDatabaseModel()
    },
    'filter.category_course_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.teacher_id': function () {
      this.fetchDatabaseModel()
    },
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 65px;
  border-radius: 2px;
  cursor: pointer;
}
.courses-info {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.courses-info span {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/projects/Index.vue